import Table, { TablePropTypes } from './Table';

export default Table;
export { TablePropTypes };
